// CENTRAL API CONFIGURATION
// Change only this URL when deploying the React app for another client.
export const API_BASE = "https://kol.cubixsystems.com/api/";
export const API_BASE_NOSLASH = API_BASE.replace(/\/$/, "");

export const apiUrl = (path = "") => `${API_BASE}${String(path).replace(/^\/+/, "")}`;
